import _ from "ES/lib/lodash";
import React from "ES/lib/react";

export default function(props){
	let className = _.isString(props.className)
		? "btn " + props.className
		: "btn btn-success";
	let is_waiting = !!props.is_waiting;
	let is_disabled = !!props.is_disabled;

	if(is_waiting || is_disabled){
		className += " disabled";
	}

	return <button type="submit" className={className}>
		{props.children}
		{is_waiting
			? <i className="fa fa-spinner fa-spin" style={{marginLeft: "1em"}} />
			: null}
	</button>;
}



// WEBPACK FOOTER //
// ./src/components/widgets/SubmitButton.js